export default function Footer() {
  return (
    <footer data-testid="site-footer" className="relative bg-obsidian border-t border-cream/10 py-16 md:py-20">
      <div className="max-w-[1440px] mx-auto px-6 md:px-12 grid grid-cols-1 md:grid-cols-12 gap-12 md:gap-6">
        <div className="md:col-span-5">
          <div className="flex items-baseline gap-2">
            <span className="font-serif text-3xl italic font-light text-cream">BB</span>
            <span className="font-sans text-xs uppercase tracking-[0.35em] text-cream/70">fit</span>
          </div>
          <p className="mt-6 max-w-sm text-cream/60 font-light text-sm leading-relaxed">
            Studio privato di allenamento personale. Un metodo su misura,
            costruito attorno alle persone che decidono di cambiare davvero.
          </p>
        </div>

        <div className="md:col-span-3 md:col-start-7">
          <div className="text-[0.62rem] uppercase tracking-[0.35em] text-gold mb-5">Studio</div>
          <ul className="space-y-3 text-cream/70 font-light text-sm">
            <li>Via Innocente Pittoni, 14 — Conegliano</li>
            <li>
              <a href="mailto:info.bbfit@gmail.com" className="nav-link">info.bbfit@gmail.com</a>
            </li>
          </ul>
        </div>

        <div className="md:col-span-3">
          <div className="text-[0.62rem] uppercase tracking-[0.35em] text-gold mb-5">Segui</div>
          <ul className="space-y-3 text-cream/70 font-light text-sm">
            <li>
              <a
                href="https://www.instagram.com/bbfitstudio/"
                target="_blank"
                rel="noreferrer"
                className="nav-link"
              >
                Instagram
              </a>
            </li>
          </ul>
        </div>
      </div>

      <div className="max-w-[1440px] mx-auto px-6 md:px-12 mt-16 md:mt-20 flex flex-col md:flex-row items-start md:items-center justify-between gap-4 border-t border-cream/10 pt-8">
        <span className="text-[0.62rem] uppercase tracking-[0.35em] text-cream/40">
          © {new Date().getFullYear()} BBfit — Tutti i diritti riservati
        </span>
        <span className="text-[0.62rem] uppercase tracking-[0.35em] text-cream/40">
          P.IVA · Privacy · Cookie
        </span>
      </div>
    </footer>
  );
}
